<ng-container *ngIf="Loader.isSpinner; else formContent">
  <app-waiting></app-waiting>
</ng-container>

<ng-template #formContent>
  <div class="passenger-info-section col" *ngIf="!!warningResults.length">
    <div class="passenger-error-section">
      <div class="passenger-error-section-row">
        <div class="passenger-error-section-row-warning-msg">
          <mat-icon fontSet="material-symbols-outlined" class="warning-icon">error</mat-icon>
          <div class="warning-text">
            <span class="font_bold" [innerHTML]="warningTextCustomize(content?.toastMessageList[3].description)"></span>
            <!-- <span>Some fields need your attention</span> -->
          </div>
        </div>
      </div>
      <div class="passenger-error-section-row" *ngFor="let control of warningResults">
        <a class="passenger-error-section-row-error-msg">{{
          control?.message
          }}</a>
        <span class="custom-fonticon-light">
          <mat-icon fontSet="material-symbols-outlined"> chevron_right </mat-icon>
        </span>
      </div>
    </div>
  </div>

  <form class="f-col blank-form" [formGroup]="companyForm">
    <div class="section-heading">
      <h2 class="h2-heading">{{content?.['b2b.managecompany.cdcompanydetails']}}</h2>

      <button type="button" class="button-as-span link" (click)="Editpersonal()"
        *ngIf="Loader.isEditableClicked"><mat-icon fontSet="material-symbols-outlined" class="edit-icon">edit</mat-icon>
        {{content?.['b2b.managecompany.cdedit']}}</button>
    </div>

    <div class="section-content" [class.view-disabled]="Loader.isEditableClicked">
      <div class="inner-contentsection">
        <div class="f-row">
          <div class="f-col">
            <mat-form-field>
              <mat-label>{{content?.['b2b.managecompany.cdcompanyname']}}</mat-label>
              <input matInput formControlName="companyName" (input)="CheckCompany($event, 'NAME')"
                (keypress)="_CommonService.blockInvalidCharacters1($event)" data-dd-privacy="mask" />
              <mat-error *ngIf="companyForm.get('companyName')?.hasError('required')">
                {{dictionaryContent?.['b2b.register.entercompanyname']}}
              </mat-error>
              <mat-error *ngIf="companyForm.get('companyName')?.hasError('maxlength')">
                {{dictionaryContent?.['b2b.managecompany.companynamemaxlimit']}}
              </mat-error>
              <mat-error *ngIf="
                companyForm.get('companyName')?.hasError('noHtmlTagsValidator')
              ">
                {{dictionaryContent?.['b2b.register.entervalidinput']}}
              </mat-error>
              <mat-error *ngIf="companyForm.get('companyName')?.hasError('CompanyExists')">
                {{dictionaryContent?.['b2b.register.companynameexists']}}
              </mat-error>
              <mat-error *ngIf="companyForm.get('companyName')?.hasError('pattern')">
                {{dictionaryContent?.['b2b.register.entervalidinput']}}
              </mat-error>
              <mat-error *ngIf="companyForm.get('companyName')?.hasError('minlength')">
                {{dictionaryContent?.['b2b.managecompany.companunameminlimit']}}
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="f-row">
          <div class="f-col">
            <mat-form-field>
              <mat-label>{{content?.['b2b.managecompany.cdbusinessnature']}}</mat-label>
              <mat-icon fontSet="material-symbols-outlined" matSuffix *ngIf="companyForm.get('natureofBusiness')?.value" (click)="companyForm.get('natureofBusiness')?.setValue(null); $event.stopPropagation()" class="clear-select-icon">close</mat-icon>
              <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select">stat_minus_1</mat-icon>
              <mat-select formControlName="natureofBusiness" (keypress)="_CommonService.blockInvalidCharacters($event)" data-dd-privacy="mask">
                <mat-option *ngFor="let option of getSiteCoreArray('b2b.register.natureofbusinessdropdown')"
                  [value]="option.Phrase">
                  {{ option.Phrase }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="companyForm.get('natureofBusiness')?.hasError('required')">
                {{dictionaryContent?.['b2b.register.selectnatureofbusiness']}}
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="form-row two--ColLayout">
          <div class="f-col">
            <mat-form-field>
              <mat-label>{{content?.['b2b.managecompany.cdcompanyregisid']}}</mat-label>
              <input matInput formControlName="registrationID" (input)="CheckCompany($event, 'REGISTRATIONID')" (keypress)="_CommonService.blockSpecialChar($event)" data-dd-privacy="mask" />
              <mat-error *ngIf="companyForm.get('registrationID')?.hasError('CompanyExists')">
                Registration ID already exists.
              </mat-error>
              <mat-error *ngIf="companyForm.get('registrationID')?.hasError('required')">
                {{dictionaryContent?.['b2b.register.enterregid']}}
              </mat-error>
              <mat-error *ngIf="companyForm.get('registrationID')?.hasError('pattern')">
                                        Registration ID must be exactly 10 digits. 
                        </mat-error>
              <mat-error *ngIf="companyForm.get('registrationID')?.hasError('minlength')">
                {{dictionaryContent?.['b2b.managecompany.registrationidcriteria']}}
              </mat-error>
              <mat-error *ngIf="companyForm.get('registrationID')?.hasError('maxlength')">
                {{dictionaryContent?.['b2b.managecompany.registrationidcriteria']}}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="f-col">
            <mat-form-field>
              <mat-label>{{content?.['b2b.managecompany.cdtaxno']}}</mat-label>
              <input matInput formControlName="taxNo" (input)="CheckCompany($event, 'TAX')" (keypress)="_CommonService.blockSpecialChar($event)" data-dd-privacy="mask" />
              <mat-error *ngIf="companyForm.get('taxNo')?.hasError('CompanyExists')">
                Tax Identification Number already exists.
              </mat-error>
              <mat-error *ngIf="companyForm.get('taxNo')?.hasError('required')">
                {{dictionaryContent?.['b2b.register.entertaxidno']}}
              </mat-error>
              <mat-error *ngIf="companyForm.get('taxNo')?.hasError('pattern')">
                {{dictionaryContent?.['b2b.register.entervalidinput']}}
              </mat-error>
              <mat-error *ngIf="companyForm.get('taxNo')?.hasError('minlength')">
                {{dictionaryContent?.['b2b.managecompany.taxidcriteria']}}
              </mat-error>
              <mat-error *ngIf="companyForm.get('taxNo')?.hasError('maxlength')">
                {{dictionaryContent?.['b2b.managecompany.taxidcriteria']}}
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="f-row two--ColLayout">
          <div class="f-col">
            <ng-select autoBlurSelect [items]="countriesLists" groupBy="group"
              [searchFn]="_CommonService.customCountrySearchFn" (change)="filterCountries($event, 'cityName')"
              formControlName="countryName" bindValue="countryName"
              [placeholder]="content?.['b2b.managecompany.countryorregion']"
              (contextmenu)="_CommonService.disableRightClick($event)" (paste)="_CommonService.onPasteBlocked($event)"
              (keypress)="_CommonService.blockInvalidCharacters($event)" data-dd-privacy="mask">
              <ng-template ng-optgroup-tmp let-item="item">
                {{ item.group }}
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                <span class="ng-option-label">
                  <ng-container *ngIf="!!item?.newFlag?.src">
                    <img [src]="getImageUrl(item?.newFlag?.src)" alt="Flag of {{ item.countryName }}" class="flag-img"
                      [height]="item.height" [width]="item.width" />
                  </ng-container>
                  {{ item.countryName }}
                </span>
              </ng-template>
              <ng-template ng-label-tmp let-item="item">
                <span class="ng-value-label"> {{ item?.countryName }} </span>
              </ng-template>
              <ng-template ng-notfound-tmp>
                <div class="no-items-found">
                  <img src="assets/images/not-found.png" alt="No items found" class="no-items-image" />
                  <p> {{dictionaryContent?.['b2b.managetraveler.nocountryfound']}}</p>
                </div>
              </ng-template>
            </ng-select>
            <mat-error class="px-4" *ngIf="
              companyForm.get('countryName')?.invalid &&
              companyForm.get('countryName')?.touched
            ">
              {{dictionaryContent?.['b2b.register.selectcountrycode'] || 'Please select country code.'}}
            </mat-error>
            <mat-error *ngIf="
              companyForm.get('countryName')?.hasError('noHtmlTagsValidator')
            ">
              {{dictionaryContent?.['b2b.register.entervalidinput']}}
            </mat-error>
            <mat-error *ngIf="companyForm.get('countryName')?.hasError('InvalidInput')">
              {{dictionaryContent?.['b2b.register.entervalidinput']}}
            </mat-error>
          </div>
          <div class="f-col view-disabled">
            <ng-select [placeholder]="content?.['b2b.managecompany.state']"></ng-select>
          </div>
        </div>


        <div class="f-row two--ColLayout">
          <div class="f-col">
            <mat-form-field>
              <mat-label>{{content?.['b2b.managecompany.district'] || 'District'}}</mat-label>
              <input matInput formControlName="districtName"
                (keypress)="_CommonService.blockInvalidCharacters1($event)" data-dd-privacy="mask" />
              <mat-error *ngIf="companyForm.get('districtName')?.hasError('required')">
                {{dictionaryContent?.['b2b.booking.districtrequired'] || 'District field is required.'}}
              </mat-error>
              <mat-error *ngIf="companyForm.get('districtName')?.hasError('minlength')">
                {{dictionaryContent?.['b2b.booking.districtminlimit'] || 'District name should be minimin 5 characters.'}}
              </mat-error>

              <mat-error *ngIf="companyForm.get('postCode')?.hasError('maxlength')">
                {{dictionaryContent?.['b2b.managecompany.districtmaxlimit'] || "District name can't exceed more than 150 characters."}}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="f-col">
            <ng-select autoBlurSelect [items]="commonObjPipes.cityName.pipe" formControlName="cityName"
              bindLabel="cityName" bindValue="cityName" [placeholder]="content?.['b2b.managecompany.city']"
              (contextmenu)="_CommonService.disableRightClick($event)" (paste)="_CommonService.onPasteBlocked($event)"
              (keypress)="_CommonService.blockInvalidCharacters($event)" data-dd-privacy="mask">
              <ng-template ng-notfound-tmp>
                <div class="no-items-found">
                  <img src="assets/images/not-found.png" alt="No items found" class="no-items-image" />
                  <p>{{content?.['b2b.managecompany.nocityfound'] || 'No city found'}}</p>
                </div>
              </ng-template>
            </ng-select>
            <mat-error class="px-4" class="px-4" *ngIf="
              companyForm.get('cityName')?.invalid &&
              companyForm.get('cityName')?.touched
            ">
              {{dictionaryContent?.['b2b.managetraveler.selectvalidcity']}}
            </mat-error>
          </div>
        </div>

        <div class="f-row two--ColLayout">
          <div class="f-col">
            <mat-form-field>
              <mat-label>{{content?.['b2b.managecompany.cdpostalcode']}}</mat-label>
              <input matInput formControlName="postCode" (keypress)="onKeyPress($event)"
                (keypress)="_CommonService.blockInvalidCharacters($event)" data-dd-privacy="mask" />
              <mat-error *ngIf="companyForm.get('postCode')?.hasError('required')">
                {{dictionaryContent?.['b2b.register.enterpostalcode']}}
              </mat-error>
              <mat-error *ngIf="companyForm.get('postCode')?.hasError('pattern')">
                {{dictionaryContent?.['b2b.register.entervalidinput']}}
              </mat-error>
              <mat-error *ngIf="companyForm.get('postCode')?.hasError('minlength')">
                {{dictionaryContent?.['b2b.register.postalcode5char']}}
              </mat-error>
              <mat-error *ngIf="companyForm.get('postCode')?.hasError('maxlength')">
                {{dictionaryContent?.['b2b.managetraveler.postalcodemaxlimit']}}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="f-col">
            <mat-form-field>
              <mat-label>{{content?.['b2b.managecompany.buildingnumber'] || 'Building Number'}}</mat-label>
              <input matInput formControlName="buildingNumber" (keypress)="onKeyPress($event)"
                (keypress)="_CommonService.blockInvalidCharacters($event)" data-dd-privacy="mask" />
              <mat-error *ngIf="companyForm.get('buildingNumber')?.hasError('required')">
                {{dictionaryContent?.['b2b.managecompany.buildingnorequired'] || 'Building number is required.'}}
              </mat-error>
              <mat-error *ngIf="companyForm.get('buildingNumber')?.hasError('pattern')">
                {{dictionaryContent?.['b2b.booking.buildingnoksalimit'] || 'Building Number is 4 only for Saudi Arabia'}}
              </mat-error>
              <!-- <mat-error *ngIf="companyForm.get('postCode')?.hasError('minlength')">
                {{dictionaryContent?.['b2b.register.postalcode5char']}}
              </mat-error> -->
              <mat-error *ngIf="companyForm.get('buildingNumber')?.hasError('maxlength')">
                {{dictionaryContent?.['b2b.managecompany.buildingnomaxlimit'] || "Building number can't exceed 15 digit."}}
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="f-row">
          <div class="f-col">
            <mat-form-field>
              <mat-label>{{content?.['b2b.managetraveler.streetaddress'] || 'Street address'}}</mat-label>
              <input matInput formControlName="address" (keypress)="blockInvalidCharacters($event, 'address')" data-dd-privacy="mask" />
              <mat-error *ngIf="companyForm.get('address')?.hasError('required')">
                {{dictionaryContent?.['b2b.booking.streetaddrisrequired']}}
              </mat-error>
              <mat-error *ngIf="companyForm.get('address')?.hasError('maxlength')">
                {{dictionaryContent?.['b2b.managecompany.streetaddessmaxlimit'] || "Street address cannot exceed 200 characters."}}
              </mat-error>
              <mat-error *ngIf="
                companyForm.get('address')?.hasError('forbiddenCharacters')
              ">
                {{dictionaryContent?.['b2b.register.entervalidinput']}}
              </mat-error>
              <mat-error *ngIf="companyForm.get('address')?.hasError('minlength')">
                {{dictionaryContent?.['b2b.managecompany.streetaddress.minlimit'] || 'Street address must be 5 to 100 characters'}}
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="f-row">
          <div class="f-col">
            <mat-form-field>
              <mat-label>{{content?.['b2b.managecompany.cdcompanyemail']}}</mat-label>
              <input matInput formControlName="emailAddress" (input)="checkEmail($event)"
                (keypress)="_CommonService.blockInvalidCharacters($event)" (keypress)="Onlyrs($event)" data-dd-privacy="mask" />
              <mat-icon fontSet="material-symbols-outlined" matSuffix>mail</mat-icon>
              <mat-error *ngIf="companyForm.get('emailAddress')?.hasError('required')">
                {{dictionaryContent?.['b2b.booking.enteremailaddress']}}
              </mat-error>
              <mat-error *ngIf="
                companyForm
                  .get('emailAddress')
                  ?.hasError('customEmailValidator')
              ">
                {{dictionaryContent?.['b2b.managecompany.validemailaddress']}}
              </mat-error>
              <mat-error *ngIf="companyForm.get('emailAddress')?.hasError('email')">
                {{dictionaryContent?.['b2b.managecompany.validemailaddress']}}
              </mat-error>
              <mat-error *ngIf="companyForm.get('emailAddress')?.hasError('maxlength')">
                {{dictionaryContent?.['b2b.managecompany.cannotexceedemailadd']}}
              </mat-error>
              <mat-error *ngIf="companyForm.get('emailAddress')?.hasError('emailExists')">
                {{dictionaryContent?.['b2b.managecompany.emailalreadyexists']}}
              </mat-error>
              <mat-error *ngIf="
                companyForm.get('emailAddress')?.hasError('forbiddenCharacters')
              ">
                {{dictionaryContent?.['b2b.register.entervalidinput']}}
              </mat-error>
              <mat-error *ngIf="companyForm.get('emailAddress')?.hasError('invalidEmail')">
                {{dictionaryContent?.['b2b.register.entervalidinput']}}
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="f-row two--ColLayout">
          <div class="f-col">
            <ng-select autoBlurSelect [items]="countriesLists" groupBy="group"
              [searchFn]="_CommonService.customCountrySearchFn" formControlName="countryCode" bindValue="isoCode"
              [placeholder]="content?.['b2b.managecompany.cdcountrycode']"
              (contextmenu)="_CommonService.disableRightClick($event)" (paste)="_CommonService.onPasteBlocked($event)"
              (keypress)="_CommonService.blockInvalidCharacters($event)" data-dd-privacy="mask">
              <ng-template ng-optgroup-tmp let-item="item">
                {{ item.group }}
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                <span class="ng-option-label">
                  <ng-container *ngIf="!!item?.newFlag?.src">
                    <img [src]="getImageUrl(item?.newFlag?.src)" alt="Flag of {{ item.countryName }}" class="flag-img"
                      [height]="item.height" [width]="item.width" />
                  </ng-container>
                  {{ item.code }} ({{ item?.countryName }})
                </span>
              </ng-template>
              <ng-template ng-label-tmp let-item="item">
                <span class="ng-value-label">
                  {{ item.code }}
                </span>
              </ng-template>
              <ng-template ng-notfound-tmp>
                <div class="no-items-found">
                  <img src="assets/images/not-found.png" alt="No items found" class="no-items-image" />
                  <p> {{dictionaryContent?.['b2b.managetraveler.nocountryfound']}}</p>
                </div>
              </ng-template>
            </ng-select>
            <mat-error class="px-4" *ngIf="companyForm.get('countryName')?.hasError('required')">
              {{dictionaryContent?.['b2b.managetraveler.entercountrycode']}}
            </mat-error>
            <mat-error class="px-4" *ngIf="
              companyForm.get('countryName')?.hasError('noHtmlTagsValidator')
            ">
              {{dictionaryContent?.['b2b.register.entervalidinput']}}
            </mat-error>
            <mat-error class="px-4" *ngIf="companyForm.get('countryName')?.hasError('InvalidInput')">
              {{dictionaryContent?.['b2b.register.entervalidinput']}}
            </mat-error>
          </div>
          <div class="f-col">
            <mat-form-field>
              <mat-label>{{content?.['b2b.managecompany.cdmobilenumber']}}</mat-label>
              <input matInput formControlName="mobileNo" (keypress)="OnlyNumbers($event)"
                (paste)="_CommonService.onPasteBlocked($event)" data-dd-privacy="mask" />
              <mat-icon fontSet="material-symbols-outlined" matSuffix>phone_android</mat-icon>
              <mat-error *ngIf="companyForm.get('mobileNo')?.hasError('required')">
                {{dictionaryContent?.['b2b.booking.entermobileno']}}
              </mat-error>
             
                  <mat-error
                            *ngIf="companyForm.get('mobileNo')?.hasError('minlength') && companyForm.get('mobileNo')?.touched">
                            {{dictionaryContent?.['b2b.managecompany.cannotexceedmobilenumber']}}
                        </mat-error>

                        <mat-error
                            *ngIf="companyForm.get('mobileNo')?.hasError('maxlength') && companyForm.get('mobileNo')?.touched">
                            {{dictionaryContent?.['b2b.managecompany.cannotexceedmobilenumber']}}
                        </mat-error>

                        <!-- <mat-error
                            *ngIf="companyForm.get('mobileNo')?.hasError('pattern') && companyForm.get('mobileNo')?.touched">
                             {{dictionaryContent?.['b2b.register.10digitmobile'] || 'Mobile number must be 10 digits.'}}
                        </mat-error> -->

            </mat-form-field>
          </div>
        </div>

        <div class="f-row two--ColLayout">
          <div class="f-col">
            <mat-form-field>
              <mat-label>{{content?.['b2b.managecompany.businessloyaltyid'] || 'Business Loyalty ID'}}</mat-label>
              <input matInput formControlName="accountNo" (keypress)="OnlyNumbers($event)" data-dd-privacy="mask" />
              <!-- <mat-icon fontSet="material-symbols-outlined" matSuffix>phone_android</mat-icon> -->
              <mat-error *ngIf="companyForm.get('accountNo')?.hasError('required')">
                {{dictionaryContent?.['b2b.managecompany.entercompanycode']}}
              </mat-error>
              <mat-error *ngIf="companyForm.get('accountNo')?.hasError('maxlength')">
                {{dictionaryContent?.['b2b.managecompany.cannotexeedcompanycode']}}
              </mat-error>
              <mat-error *ngIf="companyForm.get('accountNo')?.hasError('minlength')">
                {{dictionaryContent?.['b2b.managecompany.companycodeminlimit']}}
              </mat-error>
              <mat-error *ngIf="companyForm.get('accountNo')?.hasError('pattern')">
                {{dictionaryContent?.['b2b.register.entervalidinput']}}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="f-col">
            <mat-form-field>
              <mat-label>{{content?.['b2b.managecompany.fax']}}</mat-label>
              <input matInput formControlName="faxno" (keypress)="blockInvalidCharacters($event, 'faxno')"
                (paste)="_CommonService.onPasteBlocked($event)" autocomplete="new-password" data-dd-privacy="mask" />
              <mat-icon fontSet="material-symbols-outlined" matSuffix>phone</mat-icon>
              <mat-error *ngIf="companyForm.get('faxno')?.hasError('required')">
                {{dictionaryContent?.['b2b.managecompany.enterfaxnumber']}}
              </mat-error>
              <mat-error *ngIf="companyForm.get('faxno')?.hasError('maxlength')">
                {{dictionaryContent?.['b2b.managecompany.faxnumbermaxlimit']}}
              </mat-error>
              <mat-error *ngIf="companyForm.get('faxno')?.hasError('minlength')">
                {{dictionaryContent?.['b2b.managecompany.faxnumberminlimit']}}</mat-error>
              <mat-error *ngIf="companyForm.get('faxno')?.hasError('pattern')">
                {{dictionaryContent?.['b2b.register.entervalidinput']}}
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="f-row two--ColLayout">
          <div class="f-col">
            <mat-form-field>
              <mat-label>{{content?.['b2b.managecompany.telephone']}}</mat-label>
              <input matInput formControlName="phoneNo" (keypress)="OnlyNumbers($event)"
                (paste)="_CommonService.onPasteBlocked($event)" autocomplete="new-password" data-dd-privacy="mask" />
              <mat-icon fontSet="material-symbols-outlined" matSuffix>phone</mat-icon>
              <mat-error *ngIf="companyForm.get('phoneNo')?.hasError('required')">
                {{dictionaryContent?.['b2b.register.enterphoneno']}}
              </mat-error>
              <mat-error *ngIf="companyForm.get('phoneNo')?.hasError('maxlength')">
                {{dictionaryContent?.['b2b.managecompany.phonenumbermaxlimit']}}
              </mat-error>
              <mat-error *ngIf="companyForm.get('phoneNo')?.hasError('minlength')">
                {{dictionaryContent?.['b2b.managecompany.phonenumberminlimit']}}
              </mat-error>
              <mat-error *ngIf="companyForm.get('phoneNo')?.hasError('pattern')">
                {{dictionaryContent?.['b2b.register.entervalidinput']}}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="f-col">
            <mat-form-field>
              <mat-label>{{content?.['b2b.managecompany.cdlanguage']}}</mat-label>
              <mat-icon fontSet="material-symbols-outlined" matSuffix *ngIf="companyForm.get('language')?.value" (click)="companyForm.get('language')?.setValue(null); $event.stopPropagation()" class="clear-select-icon">close</mat-icon>
              <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select">stat_minus_1</mat-icon>
              <mat-select value="GB" formControlName="language" data-dd-privacy="mask">
                <mat-option value="GB"> English </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="f-row">
          <div class="f-col">
            <mat-form-field>
              <mat-label>{{content?.['b2b.managecompany.cdcompanyurl']}}</mat-label>
              <input matInput formControlName="websiteURL" placeholder="https://www.abc.com"
                (keypress)="blockInvalidUrl($event)" (keypress)="block($event)" data-dd-privacy="mask" />
              <mat-error *ngIf="companyForm.get('websiteURL')?.hasError('maxlength')">
                {{dictionaryContent?.['b2b.register.cannotexceedurl']}}
              </mat-error>
              <mat-error *ngIf="companyForm.get('websiteURL')?.hasError('minlength')">
                {{dictionaryContent?.['b2b.register.url5char']}}
              </mat-error>
              <mat-error *ngIf="companyForm.get('websiteURL')?.hasError('pattern')">
                {{dictionaryContent?.['b2b.register.validurl']}}
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="f-row two--ColLayout">
          <div class="f-col">
            <mat-form-field>
              <mat-label>{{content?.['b2b.managecompany.cdnumofemployee']}}</mat-label>
              <mat-icon fontSet="material-symbols-outlined" matSuffix *ngIf="companyForm.get('noOfUsers')?.value" (click)="companyForm.get('noOfUsers')?.setValue(null); $event.stopPropagation()" class="clear-select-icon">close</mat-icon>
              <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select">stat_minus_1</mat-icon>
              <mat-select formControlName="noOfUsers" (keypress)="_CommonService.blockInvalidCharacters($event)" data-dd-privacy="mask">
                <mat-option *ngFor="let option of getSiteCoreArray('b2b.register.employeecount');"
                  [value]="option.Phrase">
                  {{ option.Phrase }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="f-col">
            <mat-form-field>
              <mat-label>{{content?.['b2b.managecompany.cdannualtravelbudget']}}</mat-label>
              <mat-icon fontSet="material-symbols-outlined" matSuffix *ngIf="companyForm.get('travelBudget')?.value" (click)="companyForm.get('travelBudget')?.setValue(null); $event.stopPropagation()" class="clear-select-icon">close</mat-icon>
              <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select">stat_minus_1</mat-icon>
              <mat-select formControlName="travelBudget" required
                (keypress)="_CommonService.blockInvalidCharacters($event)" data-dd-privacy="mask">
                <mat-option *ngFor="let option of getSiteCoreArray('b2b.register.travelbudgetlist');"
                  [value]="option.Phrase">
                  {{ option.Phrase }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

      </div>
      <div class="inner-contentsection">
        <h3 class="subheading">{{content?.['b2b.managecompany.cdcorporatelogo']}}</h3>

        <div class="f-row">
          <div class="fill-manually" [ngClass]="{ 'bg-transparent p-0': !!previewUrl }">
            <!-- 🟢 When no image uploaded -->
            <ng-container *ngIf="
              !companyForm.value.companyImage ||
                companyForm.value.companyImage === 'DELETE';
              else elseImage
            ">
              <div class="f-col">
                <div class="add-text-input">{{content?.['b2b.managecompany.uploadcorporatlogo']}}</div>
                <p> {{content?.['b2b.managecompany.allowedfiletypes'] || 'Allowed file types: .jpg, .png. Logo size 250x100px.'}} </p>
              </div>
            </ng-container>

            <ng-template #elseImage>
              <!-- 🟢 When image uploaded -->
              <div class="fill-manually-submitted">
                <div class="fill-value">
                  <img [src]="previewUrl || imagePathUpdate || companyForm.value.companyImage"
                    [alt]="selectedFileName || 'Selected Image'" class="preview-url" />
                </div>
                <div class="action-links">
                  <button type="button" class="button-as-span" (click)="fileInput.click()" [ngStyle]="{
                    color: Loader.isEditableClicked ? 'gray' : 'green'
                  }">{{content?.['b2b.managecompany.cdchange']}}</button>
                  <button type="button" class="button-as-span" (click)="removeLogo()" [ngStyle]="{
                    color: Loader.isEditableClicked ? 'gray' : 'red'
                  }">{{content?.['b2b.managecompany.cdremove']}}</button>
                </div>
              </div>
            </ng-template>

            <!-- 🟢 Upload Button -->
            <button class="button-as-span custom-file-content" aria-label="upload button" (click)="fileInput.click()">
              <mat-icon fontSet="material-symbols-outlined" class="upload-icon" *ngIf="
                !companyForm.value.companyImage || companyForm.value.companyImage === 'DELETE' && !Loader.isEditableClicked
              ">add_circle</mat-icon>
              <input #fileInput id="fileInput" type="file" accept=".jpg,.png" (change)="onFileSelected($event)"
                style="display: none" />
            </button>
          </div>
        </div>

        <!-- 🟢 Validation & success messages -->
        <mat-error *ngIf="!!errorMessage">{{ errorMessage }}</mat-error>
        <div *ngIf="fileName && !errorMessage" class="success-message">
          {{content?.['b2b.managecompany.successfullyuploaded']}} {{ fileName }}
        </div>
      </div>

      <div class="inner-action" *ngIf="circleButton">
        <button mat-button class="button--secondary-small" [class.disabled]="Loader.isEditableClicked"
          (click)="Cancel()">
          {{content?.['b2b.managecompany.cancel']}}
        </button>
        <button mat-button class="button--primary-small" [class.disabled]="
          Loader.isEditableClicked ||
          companyForm.invalid ||
          companyForm.pristine ||
          fileControll == true
        " [disabled]="
          Loader.isEditableClicked ||
          companyForm.invalid ||
          companyForm.pristine ||
          fileControll == true
        " (click)="updateCompanyDetails()">
          <mat-spinner class="button" *ngIf="Loader.isSpinner"></mat-spinner>
          {{content?.['b2b.managecompany.cdsavechanges']}}
        </button>
      </div>
    </div>
  </form>
</ng-template>